import { render, staticRenderFns } from "./dynamic.vue?vue&type=template&id=27f48b0b&scoped=true&"
import script from "./dynamic.vue?vue&type=script&lang=js&"
export * from "./dynamic.vue?vue&type=script&lang=js&"
import style0 from "./dynamic.vue?vue&type=style&index=0&id=27f48b0b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f48b0b",
  null
  
)

export default component.exports